var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09877 0.5H17.9012C19.0603 0.5 20 1.43965 20 2.59877V18.4012C20 19.5603 19.0604 20.5 17.9012 20.5H2.09877C0.939651 20.5 0 19.5604 0 18.4012V2.59877C0 1.43965 0.939648 0.5 2.09877 0.5ZM2.09877 1.85802C1.68967 1.85802 1.35802 2.18967 1.35802 2.59877V14.5081L4.29918 11.5669C5.03142 10.8347 6.2186 10.8347 6.95083 11.5669L8.30807 12.9242C8.55215 13.1683 8.94787 13.1683 9.19195 12.9242L13.6742 8.44194C14.4064 7.70971 15.5936 7.70971 16.3258 8.44194L18.642 10.7581V2.59877C18.642 2.18967 18.3103 1.85802 17.9012 1.85802H2.09877ZM1.35802 18.4012V16.2759L5.18307 12.4508C5.42715 12.2067 5.82287 12.2067 6.06695 12.4508L7.42418 13.8081C8.15642 14.5403 9.3436 14.5403 10.0758 13.8081L14.5581 9.32583C14.8021 9.08175 15.1979 9.08175 15.442 9.32583L18.642 12.5259V18.4012C18.642 18.8103 18.3103 19.142 17.9012 19.142H2.09877C1.68967 19.142 1.35802 18.8103 1.35802 18.4012ZM7.5 6.75C7.5 7.44036 6.94036 8 6.25 8C5.55964 8 5 7.44036 5 6.75C5 6.05964 5.55964 5.5 6.25 5.5C6.94036 5.5 7.5 6.05964 7.5 6.75ZM8.75 6.75C8.75 8.13071 7.63071 9.25 6.25 9.25C4.86929 9.25 3.75 8.13071 3.75 6.75C3.75 5.36929 4.86929 4.25 6.25 4.25C7.63071 4.25 8.75 5.36929 8.75 6.75Z",
    fill: "url(#paint0_linear_6749_8734)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6749_8734",
    x1: 0,
    y1: 0.5,
    x2: 20,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIcon);
export default __webpack_public_path__ + "static/media/imgIcon.933c81130d8824b939b694f9de7c51b7.svg";
export { ForwardRef as ReactComponent };